module.exports = __webpack_public_path__ + "img/lf.9058593a.jpeg";